import { Form, Modal, TreeSelect } from 'antd';
import { Schedule } from '../../modules/schedules';

interface DependScheduleAddModalProps {
  visible: boolean;
  schedule: Schedule;
  scheduleList: any[];
  onCreate: (data: any) => void;
  onCancel: () => void;
}

function DependScheduleAddModal({
  visible,
  schedule,
  scheduleList,
  onCreate,
  onCancel,
}: DependScheduleAddModalProps) {
  const [form] = Form.useForm();

  const searchSubScheduleList = async (formData: any) => {
    console.log(formData);
  };

  return (
    <>
      <Modal
        open={visible}
        title="의존공정 변경"
        okText="확인"
        cancelText="취소"
        width={700}
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Form
          form={form}
          onFinish={searchSubScheduleList}
          initialValues={{
            depends: schedule.depends.map((depend) => {
              return { label: depend.name, value: depend.id };
            }),
          }}
        >
          <Form.Item name="depends">
            <TreeSelect
              showSearch
              style={{ width: '100%' }}
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder="의존공정을 선택하세요"
              allowClear
              treeDefaultExpandAll
              treeCheckStrictly
              fieldNames={{ label: 'name', value: 'id' }}
              treeCheckable
              showCheckedStrategy={'SHOW_ALL'}
              treeData={scheduleList}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default DependScheduleAddModal;
